import React from "react";
import { useTranslation } from "react-i18next";
import { BackButton } from "components/BackButton";
import { Layout } from "components/Layout";
import { useFetchTargetGroupsLvl1 } from "hooks/useQuery/useFetchTargetGroupsLvl1";
import { CategoryGroupsList } from "./risk-groups/CategoryGroupsList";

/**
 * @api {get} /riskGroups группы риска
 * @apiGroup profile
 * @apiName группы риска
 *
 * @apiDescription <p>Страница групп риска</p>
 * <p>Компонент <code>RiskGroups.js</code> <a href="../client/src/pages/RiskGroups.js">ссылка на файл</a></p>
 */

export const RiskGroups = () => {
    const { t } = useTranslation();
    const { targetGroupsLvl1, targetGroupsLvl1IsLoading, refetchTargetGroupsLvl1 } = useFetchTargetGroupsLvl1();

    React.useEffect(() => {
        refetchTargetGroupsLvl1();
    }, [refetchTargetGroupsLvl1]);

    return (
        <Layout>
            <div className="page">
                <header className="page__header">
                    <BackButton />
                    <p className="page__title">{t("risk_groups")}</p>
                </header>

                <div className="school-page__wrapper">
                    {targetGroupsLvl1IsLoading ? (
                        <p style={{ textAlign: "center", padding: "2rem" }}>Загрузка...</p>
                    ) : targetGroupsLvl1.length > 0 ? (
                        <div>
                            <h3>Целевые группы первого уровня</h3>
                            <CategoryGroupsList categories={targetGroupsLvl1} isLvl1={true} />
                        </div>
                    ) : (
                        <p style={{ textAlign: "center", padding: "2rem", color: "#888" }}>
                            Целевые группы не найдены
                        </p>
                    )}
                </div>
            </div>
        </Layout>
    );
};
